const MapDirection = (state =false, action) => {
    switch(action.type){
        case 'MAP_DIRECTION':
            return action.payload
    }
    return state;
}

export default MapDirection;


// WEBPACK FOOTER //
// ./src/reducers/MapDirection.js